// admin/src/lib/howTo.ts
//
// Wave 16d: the exercise screen's how-to (migration 0045 columns on
// `exercises`), edited as one textarea per list -- one item per line.
// Limits match the migration's checks: at most 8 items per list, each at
// most 200 characters; the focus line at most 80.

export const HOW_TO_COLUMNS =
  'description_steps_en, description_steps_he, tips_en, tips_he, mistakes_en, mistakes_he, focus_en, focus_he';

export type HowToRow = {
  description_steps_en: string[] | null;
  description_steps_he: string[] | null;
  tips_en: string[] | null;
  tips_he: string[] | null;
  mistakes_en: string[] | null;
  mistakes_he: string[] | null;
  focus_en: string | null;
  focus_he: string | null;
};

export type HowToListKey = 'description_steps' | 'tips' | 'mistakes';

export const HOW_TO_LISTS: ReadonlyArray<{ key: HowToListKey; label: string; hint: string }> = [
  { key: 'description_steps', label: 'Steps', hint: 'One step per line, in order (3-5).' },
  { key: 'tips', label: 'Tips', hint: 'One cue per line (2-4).' },
  { key: 'mistakes', label: 'Mistakes', hint: 'One common mistake per line (2-3).' },
];

export const MAX_ITEMS = 8;
export const MAX_ITEM_LENGTH = 200;
export const MAX_FOCUS_LENGTH = 80;

/** Textarea -> list: one trimmed item per non-empty line, null when empty (the app then falls back to its bundled text). */
export function linesToList(text: string): string[] | null {
  const items = text
    .split('\n')
    .map((line) => line.trim())
    .filter((line) => line.length > 0);
  return items.length > 0 ? items : null;
}

/** List -> textarea. */
export function listToLines(list: readonly string[] | null | undefined): string {
  return (list ?? []).join('\n');
}

/** Null when the textarea fits the migration's checks, else a short reason. */
export function validateHowToList(text: string): string | null {
  const items = linesToList(text) ?? [];
  if (items.length > MAX_ITEMS) return `At most ${MAX_ITEMS} lines`;
  const long = items.find((item) => item.length > MAX_ITEM_LENGTH);
  return long ? `A line is longer than ${MAX_ITEM_LENGTH} characters` : null;
}

export function validateFocus(text: string): string | null {
  return text.trim().length > MAX_FOCUS_LENGTH ? `At most ${MAX_FOCUS_LENGTH} characters` : null;
}
